import { useState, useEffect } from 'react';
import { io } from 'socket.io-client';

export const useSocket = (WEBSOCKET_URL) => {
  const [socket, setSocket] = useState(null);
  
  useEffect(() => {
    if (!WEBSOCKET_URL) {
      console.log('🔴 No WebSocket URL provided');
      return;
    }
    
    try {
      const newSocket = io(WEBSOCKET_URL, {
        transports: ['polling', 'websocket'],
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000,
      });
      
      setSocket(newSocket);
      
      newSocket.on('connect', () => {
        console.log('🟢 Socket connected with ID:', newSocket.id);
      });
      
      newSocket.on('disconnect', (reason) => {
        console.log('🔴 Socket disconnected. Reason:', reason);
      });
      
      newSocket.on('connect_error', (error) => {
        console.error('❌ Connection error:', error.message);
      });
      
      newSocket.on('transcription_update', (data) => {
        console.log('📝 Received transcription update:', data);
      });
      
      newSocket.on('stream_started', (data) => {
        console.log('🎙️ Stream started:', data);
      });
      
      newSocket.on('stream_stopped', (data) => {
        console.log('⏹️ Stream stopped:', data);
      });
      
      return () => {
        newSocket.off('connect');
        newSocket.off('disconnect');
        newSocket.off('connect_error');
        newSocket.disconnect();
      };
    } catch (error) {
      console.error('💥 Error setting up socket:', error);
    }
  }, [WEBSOCKET_URL]);
  
  return socket;
};

export default useSocket;